import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import schoolLogo from '../school-brand.jpg';
import * as Styles from './styles';

function AboutMobile() {
    const navigate = useNavigate();
    const loginTopRef = useRef(null);

    // Quick Login Drawer State
    const [showQuickLogin, setShowQuickLogin] = useState(false);
    const [quickEmail, setQuickEmail] = useState('');
    const [quickPassword, setQuickPassword] = useState('');

    // Forgot Password States
    const [isForgotMode, setIsForgotMode] = useState(false);
    const [forgotEmail, setForgotEmail] = useState('');
    const [forgotMessage, setForgotMessage] = useState('');

    const handleQuickLoginClick = () => {
        setShowQuickLogin(true);
        setIsForgotMode(false);
        setForgotMessage('');
        if (loginTopRef.current) {
            loginTopRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleQuickLogin = async (e) => {
        e.preventDefault();
        try {
            localStorage.removeItem('instructorId');
            localStorage.removeItem('learnerId');
            localStorage.removeItem('userId');
            localStorage.removeItem('adminToken');

            const response = await fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: quickEmail, password: quickPassword })
            });
            const data = await response.json();
            if (response.ok) {
                localStorage.setItem('needsPasswordReset', data.needsPasswordReset ? 'true' : 'false');

                if (data.role === 'admin') {
                    localStorage.setItem('userRole', 'admin');
                    localStorage.setItem('adminToken', data.token || 'mock-admin-token-secure');
                    window.location.assign('/admin');
                } else if (data.role === 'instructor') {
                    localStorage.setItem('userRole', 'instructor');
                    localStorage.setItem('instructorId', data.id || data.instructorId);
                    localStorage.setItem('token', data.token || '');
                    window.location.assign('/instructor-dash');
                } else {
                    localStorage.setItem('userRole', 'learner');
                    localStorage.setItem('userId', data.id || data.userId);
                    localStorage.setItem('learnerId', data.id || data.userId);
                    localStorage.setItem('userName', data.name || "Learner Driver");
                    localStorage.setItem('token', data.token || '');
                    window.location.assign(`/learner-dash/${data.instructor_id || 5}`);
                }
            } else {
                alert(data.error || "Login failed.");
            }
        } catch (err) {
            alert("Server error.");
        }
    };

    const handleForgotPasswordSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch('/api/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: forgotEmail })
            });
            const data = await res.json();
            if (res.ok) {
                setForgotMessage('Password reset link sent! Check your email.');
            } else {
                setForgotMessage(data.error || 'Could not send reset link.');
            }
        } catch (err) {
            setForgotMessage('Server error. Please try again.');
        }
    };

    return (
        <div style={{ ...Styles.containerStyle, minHeight: '100vh', background: '#0f172a', color: '#ffffff', boxSizing: 'border-box', display: 'flex', flexDirection: 'column' }}>
            
            {/* --- TOP ANCHOR REF FOR QUICK LOGIN --- */}
            <div ref={loginTopRef} />

            {/* --- UNIFORM APP HEADER --- */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', background: '#090d16', borderBottom: '1px solid rgba(255,255,255,0.06)', position: 'sticky', top: 0, zIndex: 1000 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <img src={schoolLogo} alt="Logo" style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #10b981' }} />
                    <Link to="/" style={{ color: '#fff', fontWeight: '800', fontSize: '1.1rem', letterSpacing: '-0.5px', textDecoration: 'none' }}>LessonLane</Link>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <Link to="/" title="Home" style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', padding: '6px 10px', borderRadius: '8px', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="#FFFFFF"/>
                        </svg>
                    </Link>
                    <button 
                        onClick={handleQuickLoginClick}
                        title="Portal Login"
                        style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px' }}
                    >
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C9.24 2 7 4.24 7 7C7 9.42 8.74 11.43 11 11.9V13.1C7.58 13.54 5 16.48 5 20H19C19 16.48 16.42 13.54 13 13.1V11.9C15.26 11.43 17 9.42 17 7C17 4.24 14.76 2 12 2Z" fill="#FFFFFF"/>
                        </svg>
                    </button>
                </div>
            </div>

            {/* --- QUICK LOGIN / FORGOT PASSWORD EXPANDABLE BOX --- */}
            {showQuickLogin && (
                <div style={{ padding: '16px 16px 0 16px', maxWidth: '500px', margin: '0 auto', width: '100%', boxSizing: 'border-box' }}>
                    {!isForgotMode ? (
                        <form onSubmit={handleQuickLogin} style={{ background: '#162238', padding: '18px', borderRadius: '14px', border: '1.5px solid #10b981', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.4)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                <h4 style={{ margin: 0, fontSize: '0.95rem', color: '#ffffff', fontWeight: '800' }}>Portal Sign In</h4>
                                <button type="button" onClick={() => setShowQuickLogin(false)} style={{ background: 'none', border: 'none', fontSize: '14px', cursor: 'pointer', color: '#94a3b8' }}>✕</button>
                            </div>
                            <input 
                                type="email" 
                                placeholder="Email address" 
                                value={quickEmail} 
                                onChange={e => setQuickEmail(e.target.value)} 
                                required 
                                style={{ width: '100%', padding: '10px 12px', marginBottom: '8px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
                            />
                            <input 
                                type="password" 
                                placeholder="Password" 
                                value={quickPassword} 
                                onChange={e => setQuickPassword(e.target.value)} 
                                required 
                                style={{ width: '100%', padding: '10px 12px', marginBottom: '6px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
                            />
                            <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                                <button 
                                    type="button"
                                    onClick={() => { setIsForgotMode(true); setForgotMessage(''); }}
                                    style={{ background: 'none', border: 'none', fontSize: '11.5px', color: '#10b981', textDecoration: 'none', cursor: 'pointer', padding: 0 }}
                                >
                                    Forgot password?
                                </button>
                            </div>
                            <button type="submit" style={{ width: '100%', padding: '10px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}>
                                Sign In ➔
                            </button>
                        </form>
                    ) : (
                        <form onSubmit={handleForgotPasswordSubmit} style={{ background: '#162238', padding: '18px', borderRadius: '14px', border: '1.5px solid #10b981', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.4)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                <h4 style={{ margin: 0, fontSize: '0.95rem', color: '#ffffff', fontWeight: '800' }}>Reset Password</h4>
                                <button type="button" onClick={() => setShowQuickLogin(false)} style={{ background: 'none', border: 'none', fontSize: '14px', cursor: 'pointer', color: '#94a3b8' }}>✕</button>
                            </div>
                            <p style={{ fontSize: '11.5px', color: '#94a3b8', marginBottom: '10px', lineHeight: '1.4' }}>
                                Enter your account email and we'll send you a recovery link.
                            </p>
                            <input 
                                type="email" 
                                placeholder="Enter your email address" 
                                value={forgotEmail} 
                                onChange={e => setForgotEmail(e.target.value)} 
                                required 
                                style={{ width: '100%', padding: '10px 12px', marginBottom: '8px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
                            />
                            {forgotMessage && (
                                <div style={{ fontSize: '11.5px', color: forgotMessage.includes('sent') ? '#10b981' : '#f87171', marginBottom: '8px' }}>
                                    {forgotMessage}
                                </div>
                            )}
                            <button type="submit" style={{ width: '100%', padding: '10px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', marginBottom: '8px' }}>
                                Send Reset Link ➔
                            </button>
                            <div style={{ textAlign: 'center' }}>
                                <button 
                                    type="button" 
                                    onClick={() => setIsForgotMode(false)}
                                    style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '11px', cursor: 'pointer', textDecoration: 'underline' }}
                                >
                                    Back to Sign In
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            )}

            {/* ================================
                HERO SECTION
            ================================= */}
            <section style={{ padding: '30px 16px 20px', textAlign: 'center' }}>
                <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                    <div style={{ color: '#10b981', fontSize: '0.72rem', fontWeight: '800', letterSpacing: '1.2px', marginBottom: '6px' }}>
                        ABOUT LESSONLANE
                    </div>

                    <h1 style={{ fontSize: 'clamp(1.6rem, 3.5vw, 2.2rem)', lineHeight: '1.25', margin: '0 0 10px', fontWeight: '900', letterSpacing: '-0.5px', color: '#ffffff' }}>
                        Driving Education, Reimagined.
                    </h1>

                    <p style={{ maxWidth: '450px', margin: '0 auto', fontSize: '0.85rem', lineHeight: '1.5', color: '#94a3b8' }}>
                        We’re on a mission to cut out the paperwork chaos for independent driving instructors and give learners a clearer path to passing their test.
                    </p>
                </div>
            </section>

            {/* ================================
                TWO EXPERIENCES (CLEAN SIDE-BY-SIDE CARDS)
            ================================= */}
            <section style={{ padding: '20px 16px' }}>
                <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                    
                    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                        <div style={{ color: '#10b981', fontSize: '0.68rem', fontWeight: '800', letterSpacing: '1px', marginBottom: '4px' }}>
                            DESIGNED FOR BOTH SIDES
                        </div>
                        <h2 style={{ fontSize: '1.2rem', margin: 0, fontWeight: '800', color: '#ffffff' }}>
                            One platform. Two dedicated experiences.
                        </h2>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                        
                        {/* Instructors Card */}
                        <div style={{ background: '#162238', padding: '18px 16px', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.08)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                                <div style={{ width: '32px', height: '32px', background: 'rgba(16, 185, 129, 0.15)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981', fontWeight: '800', fontSize: '14px' }}>
                                    IN
                                </div>
                                <h3 style={{ fontSize: '1.05rem', margin: 0, fontWeight: '800', color: '#ffffff' }}>For Independent Instructors</h3>
                            </div>
                            <p style={{ color: '#94a3b8', lineHeight: '1.4', marginBottom: '12px', fontSize: '0.82rem' }}>
                                Run your driving business on your own terms with total control over your diary and DVSA-aligned tracking.
                            </p>
                            <div style={{ display: 'grid', gap: '6px' }}>
                                {[
                                    'Set weekly hours and availability slots',
                                    'Manage calendar bookings effortlessly',
                                    'Track student progress with DVSA frameworks',
                                    'Message learners directly in one secure place',
                                ].map((item) => (
                                    <div key={item} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', color: '#cbd5e1', fontSize: '0.8rem' }}>
                                        <span style={{ color: '#10b981', fontWeight: '800' }}>✓</span>
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Learners Card */}
                        <div style={{ background: '#162238', padding: '18px 16px', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.08)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                                <div style={{ width: '32px', height: '32px', background: 'rgba(16, 185, 129, 0.15)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981', fontWeight: '800', fontSize: '14px' }}>
                                    LD
                                </div>
                                <h3 style={{ fontSize: '1.05rem', margin: 0, fontWeight: '800', color: '#ffffff' }}>For Learner Drivers</h3>
                            </div>
                            <p style={{ color: '#94a3b8', lineHeight: '1.4', marginBottom: '12px', fontSize: '0.82rem' }}>
                                Know exactly where you stand, what skills you've mastered, and how close you are to test readiness.
                            </p>
                            <div style={{ display: 'grid', gap: '6px' }}>
                                {[
                                    'View your weekly lesson schedule at a glance',
                                    'Request or manage lesson slots easily',
                                    'Chat directly with your instructor anytime',
                                    'Monitor your test-readiness with confidence',
                                ].map((item) => (
                                    <div key={item} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', color: '#cbd5e1', fontSize: '0.8rem' }}>
                                        <span style={{ color: '#10b981', fontWeight: '800' }}>✓</span>
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>

                </div>
            </section>

            {/* ================================
                WHY LESSONLANE (UNIFORM ICON CARDS)
            ================================= */}
            <section style={{ padding: '25px 16px' }}>
                <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                        <div style={{ color: '#10b981', fontSize: '0.7rem', fontWeight: '800', letterSpacing: '1px', marginBottom: '4px' }}>
                            WHY LESSONLANE
                        </div>
                        <h2 style={{ fontSize: '1.3rem', margin: 0, fontWeight: '800', color: '#ffffff' }}>
                            Less admin. More teaching.
                        </h2>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {[
                            {
                                title: 'Simple',
                                desc: 'Everything you need, without unnecessary complexity.',
                                svg: (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                                    </svg>
                                )
                            },
                            {
                                title: 'Organised',
                                desc: 'Keep schedules, bookings and student records together.',
                                svg: (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                    </svg>
                                )
                            },
                            {
                                title: 'Connected',
                                desc: 'Keep instructors and learners connected through their portals.',
                                svg: (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                                    </svg>
                                )
                            },
                            {
                                title: 'Track Progress',
                                desc: 'Keep learner progress and development in view.',
                                svg: (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                                        <polyline points="17 6 23 6 23 12"></polyline>
                                    </svg>
                                )
                            }
                        ].map((item) => (
                            <div 
                                key={item.title} 
                                style={{ 
                                    background: '#162238', 
                                    padding: '14px 16px', 
                                    borderRadius: '14px', 
                                    border: '1px solid rgba(255,255,255,0.06)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '14px'
                                }}
                            >
                                <div style={{ 
                                    width: '42px', 
                                    height: '42px', 
                                    background: '#0f172a', 
                                    borderRadius: '10px', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    border: '1px solid rgba(16, 185, 129, 0.3)',
                                    flexShrink: 0
                                }}>
                                    {item.svg}
                                </div>
                                <div>
                                    <h3 style={{ margin: '0 0 2px', fontSize: '0.95rem', fontWeight: '800', color: '#ffffff' }}>{item.title}</h3>
                                    <p style={{ color: '#94a3b8', lineHeight: '1.3', margin: 0, fontSize: '0.78rem' }}>
                                        {item.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================================
                CTA SECTION
            ================================= */}
            <section style={{ padding: '25px 16px 40px', textAlign: 'center', background: '#162238', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                <div style={{ maxWidth: '500px', margin: '0 auto' }}>
                    <h2 style={{ fontSize: '1.2rem', margin: '0 0 6px', fontWeight: '800', color: '#ffffff' }}>
                        Ready to simplify driving lessons?
                    </h2>
                    <p style={{ color: '#94a3b8', fontSize: '0.8rem', lineHeight: '1.4', marginBottom: '14px' }}>
                        Join LessonLane to manage lessons, schedules, and progress with ease.
                    </p>

                    <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                        <Link to="/apply" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}>
                            <button style={{ padding: '10px 18px', borderRadius: '8px', border: 'none', background: '#10b981', color: '#ffffff', fontWeight: '700', fontSize: '0.78rem', cursor: 'pointer' }}>
                                Get Started
                            </button>
                        </Link>
                        <Link to="/faq" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}>
                            <button style={{ padding: '10px 18px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'transparent', color: '#ffffff', fontWeight: '700', fontSize: '0.78rem', cursor: 'pointer' }}>
                                View FAQ
                            </button>
                        </Link>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default AboutMobile;